import React from 'react';
import css from './styles/guide.module.css';

export const GuideWrapper: React.FC<React.PropsWithChildren> = ({
  children,
}) => (
  <div className={css.container}>
    <div className={css.wrapper}>{children}</div>
  </div>
);

export const GuideTitle: React.FC<React.PropsWithChildren> = ({ children }) => (
  <h2 className={css.title}>{children}</h2>
);

export const GuideHeader: React.FC<React.PropsWithChildren> = ({
  children,
}) => <h3 className={css.header}>{children}</h3>;

export const GuideSection: React.FC<
  React.PropsWithChildren<{ id?: string }>
> = ({ id, children }) => (
  <div className={css.section} id={id}>
    {children}
  </div>
);

export const SingleSpacedList: React.FC<
  React.PropsWithChildren<{ listType?: string }>
> = ({ listType = 'unordered', children }) => {
  const ListComponent = listType === 'unordered' ? 'ul' : 'ol';
  return (
    <ListComponent className={css.singleSpacedList}>{children}</ListComponent>
  );
};

export const LargeText: React.FC<React.PropsWithChildren> = ({ children }) => (
  <span className={css.largeText}>{children}</span>
);

export const TextWithColor: React.FC<React.PropsWithChildren> = ({
  children,
}) => <span className={css.textColor}>{children}</span>;

export const IntextCitation: React.FC<React.PropsWithChildren> = ({
  children,
}) => <span className={css.intextCitation}>{children}</span>;

export const CitationBlockMini: React.FC<React.PropsWithChildren> = ({
  children,
}) => <div className={css.blockMini}>{children}</div>;

export const CitationBlock: React.FC<
  React.PropsWithChildren<{ header: string }>
> = ({ header, children }) => (
  <div className={css.block}>
    <div className={css.blockHeader}>{header}</div>
    <div className={css.innerBlock}>
      <div className={css.blockText}>{children}</div>
      <CitationBlockIcon />
    </div>
  </div>
);

const CitationBlockIcon: React.FC = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={css.blockIcon}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.898 2.864a2 2 0 0 0-4 0 2 2 0 1 0 4 0Zm8 0a2 2 0 1 0-4 0 2 2 0 1 0 4 0Zm-12 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm12 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z"
      fill="currentColor"
    />
  </svg>
);

export const CitationExampleBox: React.FC<React.PropsWithChildren> = ({
  children,
}) => <div className={css.exampleBox}>{children}</div>;

export const CitationExampleInList: React.FC<React.PropsWithChildren> = ({
  children,
}) => <p className={css.exampleInList}>{children}</p>;
